import CreateNewContainer from "../../../../Components/Applications/Project/CreateNew/CreateNewContainer";

const CreateNew = () => {
  return <CreateNewContainer />;
};

export default CreateNew;
